import * as _ from "lodash";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { User } from "../models";
import { environment } from "../../environments/environment";
import { Location } from "@angular/common";

@Injectable()
export class AuthorizationService {
  private healthcareTopBar: any;
  private CHECK_IF_TOPBAR_HAS_LOADED_INTERVAL = 1000;
  private features: any[] = [];
  private timer!: ReturnType<typeof setInterval>;
  private _topBarLoaded = false;
  private readyResolved = false;

  private healthcareLoadedSubject = new Subject<void>();
  public healthcareLoadedSubject$ = this.healthcareLoadedSubject.asObservable();

  private _readyResolve!: () => void;
  readonly ready = new Promise<void>((res) => (this._readyResolve = res));

  constructor(private _http: HttpClient, private location: Location) {
    this.timer = setInterval(() => {
      this.waitForTopBarToLoad();
    }, this.CHECK_IF_TOPBAR_HAS_LOADED_INTERVAL);
  }

  public setHealthcareTopBar(topBar: any) {
    this.healthcareTopBar = topBar;
  }

  public get HealthcareTopBar(): any {
    return this.healthcareTopBar ? this.healthcareTopBar : null;
  }

  public get topBarLoaded() {
    return this._topBarLoaded;
  }
  
  public async waitUntilReady(): Promise<void> {
    return this.ready;
  }
  
  public async isAuthenticated(): Promise<boolean> {
    await this.waitUntilReady();
    return this.healthcareTopBar.healthcareAuth.isAuthenticated();
  }

  private waitForTopBarToLoad(): boolean {
    if (!this.HealthcareTopBar || !this.HealthcareTopBar.currentUserDetails) {
      return false;
    }

    this.features = this.HealthcareTopBar.currentUserDetails.Features.filter(
      (obj) =>
        obj.App === environment.applicationName ||
        obj.App === environment.applicationName
    );
    this._topBarLoaded = true;

    if (!this.readyResolved) {
      this.readyResolved = true;
      this._readyResolve?.();
    }

    this.healthcareLoadedSubject.next();
    clearTimeout(this.timer);
    return true;
  }

  // Do not bind this without using cache to the DOM
  public hasFeature(featureName: string, useCache: boolean = false): boolean {
    if (!this.HealthcareTopBar || !this.HealthcareTopBar.currentUserDetails) {
      return false;
    }

    const collection = useCache
      ? this.features
      : this.HealthcareTopBar.currentUserDetails.Features;

    // First check for APPLINK
    const hasApplink = collection.some(
      (f) =>
        f.Name === environment.applicationApplinkFeature &&
        f.App === environment.applicationName
    );

    // If they don't have APPLINK, they don't have any CM features (by our rules)
    if (!hasApplink) {
      return false;
    }

    // Now check for the requested feature (this also works when featureName IS APPLINK)
    const hasRequestedFeature = collection.some(
      (f) => f.Name === featureName && f.App === environment.applicationName
    );

    return hasRequestedFeature;
  }

  public async hasFeatureAsync(
    featureName: string,
    useCache: boolean = true
  ): Promise<boolean> {
    await this.waitUntilReady();
    return this.hasFeature(featureName, useCache);
  }

  async CurrentUser(): Promise<User> {
    return await this._http
      .get<User>(environment.authZApiRoot.url + "/CurrentUser")
      .toPromise<User>();
  }

  GetLookerUrl(clientId: string, slugId: string): Observable<any> {
    const authheaders = new HttpHeaders();
    authheaders.append("Content-Type", "application/json");
    authheaders.append("Access-Control-Allow-Origin", "*");
    authheaders.append(
      "Access-Control-Allow-Methods",
      "GET, POST, OPTIONS, PUT, PATCH, DELETE"
    );
    return this._http.get<any>(
      `${environment.authZApiRoot.url}/LookerUrl/Clients/${clientId}/slugIds/${slugId}`,
      { headers: authheaders }
    );
  }
}
